import React, { ComponentType } from 'react';

import {
  CustomItem,
  MenuGroup,
  LinkItem,
  MenuGroupProps,
  LinkItemProps,
  Section,
} from '@atlaskit/menu';

type DropdownItemProps = LinkItemProps & {
  linkComponent?: ComponentType<React.PropsWithChildren<any>>;
};

export const DropdownItem = ({
  iconBefore,
  iconAfter,
  linkComponent,
  ...props
}: DropdownItemProps): JSX.Element => {
  return linkComponent ? (
    <CustomItem
      component={linkComponent}
      iconBefore={iconBefore}
      iconAfter={iconAfter}
      {...props}
    />
  ) : (
    <LinkItem iconBefore={iconBefore} iconAfter={iconAfter} {...props} />
  );
};

type DropdownItemGroupProps = MenuGroupProps & {
  title?: string;
  hasSeparator?: boolean;
};

export const DropdownItemGroup = ({
  hasSeparator = false,
  ...props
}: DropdownItemGroupProps): JSX.Element => {
  const { children, title, ...menuProps } = props;
  return (
    <MenuGroup {...menuProps}>
      <Section title={title} hasSeparator={hasSeparator}>
        {children}
      </Section>
    </MenuGroup>
  );
};
